/**
 * Mini Card Features – Featured Collection Only
 * -----------------------------------------------
 * 1. Horizontal image slider with progress bar
 * 2. Quick-add button (ALWAYS AJAX, never redirect)
 * 3. Tap-to-navigate on card media (heading overlay disabled via CSS)
 *
 * DOM (after fix):
 *   .card-wrapper.card-wrapper--has-mini
 *     .card
 *       .card__inner
 *         .card__media[data-product-url]    <- positioning context, JS click handler
 *           .media                           <- theme images only
 *             <img>
 *           .mini-media-slider              <- sibling of .media (not child!)
 *           .mini-media-scrollbar           <- sibling of .media
 *           .mini-quick-add                 <- sibling of .media
 */
(function () {
  'use strict';

  console.log('[mini-card] script loaded');

  var SWIPE_THRESHOLD = 8; // px

  /* ===== SLIDER ===== */

  function initSlider(slider) {
    var startX = 0;
    var didSwipe = false;

    slider.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      didSwipe = false;
    }, { passive: true });

    slider.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - startX) > SWIPE_THRESHOLD) {
        didSwipe = true;
      }
    }, { passive: true });

    // Capture-phase: block click only after a real swipe (not a tap)
    slider.addEventListener('click', function (e) {
      if (didSwipe) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true); // capture = true

    /* --- Scrollbar sync ---
       Slider and scrollbar are siblings inside .card__media */
    var syncScrollbar = function () {
      var container = slider.parentElement;
      if (!container) return;
      var bar = container.querySelector('.mini-media-scrollbar');
      var thumb = bar ? bar.querySelector('.mini-media-thumb') : null;
      if (!bar || !thumb) return;

      var max = slider.scrollWidth - slider.clientWidth;
      if (max <= 0) {
        bar.style.display = 'none';
        return;
      }
      bar.style.display = '';

      var ratio = slider.clientWidth / slider.scrollWidth;
      thumb.style.width = Math.max(20, ratio * 100) + '%';

      var progress = slider.scrollLeft / max;
      var track = bar.clientWidth - thumb.offsetWidth;
      thumb.style.transform = 'translateX(' + (track * progress) + 'px)';
    };

    slider.addEventListener('scroll', syncScrollbar, { passive: true });
    syncScrollbar();

    if (window.ResizeObserver) {
      new ResizeObserver(syncScrollbar).observe(slider);
    }

    console.log('[mini-card] slider init OK, slides:', slider.querySelectorAll('.mini-media-slide').length);
  }

  /* ===== CARD MEDIA NAVIGATION ===== */

  /**
   * Since the heading overlay (.card__heading a::after) is disabled
   * via pointer-events:none for our cards, we handle tap-to-navigate
   * on the entire .card__media area via JS.
   */
  function initCardMedia(media) {
    var startX = 0;
    var startY = 0;

    media.addEventListener('pointerdown', function (e) {
      startX = e.clientX;
      startY = e.clientY;
    }, { passive: true });

    media.addEventListener('click', function (e) {
      // Don't navigate if click was on the quick-add button
      if (e.target.closest('.mini-quick-add')) return;
      // Don't navigate if user was swiping/dragging
      if (Math.abs(e.clientX - startX) > SWIPE_THRESHOLD) return;
      if (Math.abs(e.clientY - startY) > SWIPE_THRESHOLD) return;

      var url = media.dataset.productUrl;
      if (url) {
        window.location.href = url;
      }
    });
  }

  /* ===== QUICK ADD ===== */

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (res) {
      if (!res.ok) {
        return res.json().catch(function () { return null; }).then(function (err) {
          throw err || new Error('Cart add failed');
        });
      }
      return res.json();
    });
  }

  function refreshAndOpenDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) {
      toast('Ajouté au panier');
      return Promise.resolve();
    }

    return fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function (res) {
        if (!res.ok) throw new Error('sections fetch failed');
        return res.json();
      })
      .then(function (sections) {
        if (typeof drawer.renderContents === 'function') {
          drawer.renderContents({ sections: sections });
        } else {
          // Manual fallback
          var drawerEl = document.getElementById('CartDrawer');
          if (drawerEl && sections['cart-drawer']) {
            var parsed = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
            var inner = parsed.querySelector('#CartDrawer');
            if (inner) drawerEl.innerHTML = inner.innerHTML;
          }
          var bubble = document.getElementById('cart-icon-bubble');
          if (bubble && sections['cart-icon-bubble']) {
            var p2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
            var b2 = p2.querySelector('.shopify-section');
            if (b2) bubble.innerHTML = b2.innerHTML;
          }
          drawer.open();
        }
      })
      .catch(function (err) {
        console.warn('[mini-card] drawer refresh failed, opening anyway', err);
        try { drawer.open(); } catch (e) { /* ignore */ }
      });
  }

  function toast(msg) {
    var el = document.createElement('div');
    el.textContent = msg;
    el.style.cssText = 'position:fixed;left:50%;bottom:20px;transform:translateX(-50%);padding:10px 18px;border-radius:8px;background:rgba(0,0,0,.85);color:#fff;z-index:9999;font-size:14px;font-weight:500;pointer-events:none;white-space:nowrap;box-shadow:0 4px 14px rgba(0,0,0,.25)';
    document.body.appendChild(el);
    setTimeout(function () {
      el.style.transition = 'opacity .3s';
      el.style.opacity = '0';
      setTimeout(function () { el.remove(); }, 350);
    }, 1600);
  }

  /**
   * Delegated click handler for .mini-quick-add buttons.
   * - Multi-variant products have data-has-variants="true" and are wrapped
   *   in a <modal-opener>, which handles the click natively → skip here.
   * - Single-variant products → AJAX add-to-cart directly.
   */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.mini-quick-add');
    if (!btn) return;

    // Multi-variant: let the native <modal-opener> handle the click
    if (btn.dataset.hasVariants === 'true') return;

    e.preventDefault();
    e.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) {
      console.warn('[mini-card] no variant ID on button');
      return;
    }

    console.log('[mini-card] adding to cart, variant:', variantId);
    btn.classList.add('is-loading');
    btn.disabled = true;

    addToCart(variantId)
      .then(function () {
        return refreshAndOpenDrawer();
      })
      .catch(function (err) {
        toast('Erreur ajout panier');
        console.error('[mini-card] add-to-cart error', err);
      })
      .then(function () {
        // finally block
        btn.disabled = false;
        btn.classList.remove('is-loading');
      });
  });

  /* ===== COLOR SWATCHES ===== */

  /**
   * Delegated click handler for .mini-swatch buttons.
   * On click:
   *  1. Mark swatch as active (outline + aria-selected)
   *  2. If mini-slider exists → scroll to the matching slide (data-media-id)
   *  3. If no slider → swap the main <img> src/srcset in .media
   *  4. Update the quick-add "+" button variant ID
   */
  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.mini-swatch');
    if (!swatch) return;

    e.preventDefault();
    e.stopPropagation();

    var swatchRow = swatch.closest('.mini-swatches');
    if (!swatchRow) return;

    // 1. Toggle active
    var all = swatchRow.querySelectorAll('.mini-swatch');
    all.forEach(function (s) {
      s.classList.remove('mini-swatch--active');
      s.setAttribute('aria-selected', 'false');
    });
    swatch.classList.add('mini-swatch--active');
    swatch.setAttribute('aria-selected', 'true');

    var mediaId = swatch.dataset.mediaId;
    var imageUrl = swatch.dataset.imageUrl;
    var variantId = swatch.dataset.variantId;
    var card = swatch.closest('.card-wrapper');
    if (!card) return;

    // 2. Sync slider or swap main image
    var slider = card.querySelector('[data-mini-slider]');
    var scrolled = false;

    if (slider && mediaId) {
      var slides = slider.querySelectorAll('[data-media-id]');
      for (var i = 0; i < slides.length; i++) {
        if (slides[i].dataset.mediaId === mediaId) {
          slider.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          scrolled = true;
          break;
        }
      }
    }

    // No slider match → swap the static <img> directly
    if (!scrolled && imageUrl) {
      var mainImg = card.querySelector('.card__media .media > img:first-child');
      if (mainImg) {
        var base = imageUrl.replace(/&width=\d+/, '');
        var ws = [165, 360, 533, 720, 940, 1066];
        mainImg.srcset = ws.map(function (w) {
          return base + '&width=' + w + ' ' + w + 'w';
        }).join(', ');
        mainImg.src = imageUrl;
      }
    }

    // 3. Update quick-add button variant
    if (variantId) {
      var btn = card.querySelector('.mini-quick-add');
      if (btn) btn.dataset.variantId = variantId;
    }
  });

  /* ===== INIT ===== */

  function initAll() {
    var sliders = document.querySelectorAll('[data-mini-slider]');
    var medias = document.querySelectorAll('.card__media[data-product-url]');
    console.log('[mini-card] init: found', sliders.length, 'sliders,', medias.length, 'card medias');

    sliders.forEach(initSlider);
    medias.forEach(initCardMedia);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
